import 'react-tabulator/lib/styles.css'; 
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import '../../resources/css/maintenance/CloudAccountList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactExport from "react-data-export";
import { withRouter } from 'react-router-dom';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { Row } from 'react-bootstrap';
import { listDateFormatter } from '../../components/common/access-list';
import { forwardAccountList, getAccountsData,  removeAccount, DELETE_CLOUD_ACCOUNT_SUCCESS, DELETE_CLOUD_ACCOUNT_FAIL, WAIT_INIT_ACCOUNTS } from '../../actions/cloud-account/index';
import FilterSearch from '../common/FilterSearch';
import ListSettingBtn from '../common/ListSettingBtn';
import CommonListFooter from '../common/CommonListFooter';
import { updateMaxPageNumber, getTableInfoFromSession, reloadTable, groupMenuTitleFormatter, commonListFooter } from '../common/access-list';
import Loading from '../../components/common/Loading';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let deleteRow;

const GroupBtnsMenu = (props) => {
  // const cellData = props.cell._cell.row.data;
  return (
      <div className='group-buttons-menu'>
          <span className='operation-button-area'>
            <span className='btn-area'><span className='icon-btn-remove' onClick={() => deleteRow(props)}/></span>
          </span>
          <span className='more-button-area'>
            <span className='btn-area'><span className='icon-btn-more-dark'/></span>
          </span>
      </div>
  );
};

class CloudAccountList extends Component {
  tableId = 'cloudAccountList'
  refFilterSearch = null
  refListCommonFooter = null
  // set this state for re-fresh sub component
  state = {
    refTable: null,
    isInitComplete: false,
    filterColumns: [
      { title: "Account", field: "email", visible: true }
    ],
    /**
     *  visibleColumnsConfig is array
     *  title is menu tile
     *  columns is all changed visible columns for table list to display
     */
    visibleColumnsConfig : {
      title: 'Visible Columns',
      columns: [
        { name:'email', title: "Account", field: "email" },
        { name:'createDate', title: "Created Date", field: "createDate" },
        { name:'lastModifiedDate', title: "Last Modified Date", field: "lastModifiedDate" }
      ]
    },
    sessionKey: window.CONFIG.PROJECT_ID + '.AccountListParams'
  }

  constructor(props) {
    super(props);

    // bind this props to function
    this.dataLoading = this.dataLoading.bind(this);
    deleteRow = this.deleteRow.bind(this);

    // this component use props
    this.ref = null;
    this.rowClickType = null;
  };

  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
   *  
   ***/
  columns = [
    { title: "Uid", field: "uid", visible: false },
    { title: "Account", field: "email" },
    { title: "Created Date", field: "createDate", formatter: listDateFormatter, formatterParams:{dateFormat:'YYYY/MM/DD'} },
    { title: "Last Modified Date", field: "lastModifiedDate", formatter: listDateFormatter, formatterParams:{dateFormat:'YYYY/MM/DD'} },
    { title: "", field: "buttonGroup", minWidth: 180, headerSort:false, formatter: reactFormatter(<GroupBtnsMenu />),
      titleFormatter: groupMenuTitleFormatter, titleFormatterParams:{tableId : 'cloudAccountList'}}
  ];

  dataLoading = (datas) => {
    // const { status, reloadPageNumber } = this.props;
    if (this.ref && !this.state.isInitComplete) {
      // if not init and ref has data      
      // step1. init go to page button and change pagination button
      this.refListCommonFooter.initCommonListFooter();

      // step2. init page max label
      const table = this.ref.table;
      updateMaxPageNumber(table);

      // step3. init page buttons
      this.refListCommonFooter.overwritePageBtns();

      // step4. pagination init complete, save into state
      this.setState({
        isInitComplete:true,
        refTable:this.ref.table
      });

      // step5. if has reload table form session, reload it
      const { sessionKey } = this.state;
      const keepTableInfo = getTableInfoFromSession(sessionKey);
      if (keepTableInfo) {
        setTimeout(() => {
          reloadTable(table, keepTableInfo, this.refFilterSearch);
        }, 50);
      }
    }
  }

  reloadList = (e) => {
    const { idToken, getAccountsData, forwardAccountList } = this.props;
    if (idToken) {
      forwardAccountList();
      getAccountsData(idToken);
    }
  }

  deleteRow = (props) => {
    this.rowClickType = 'DELETE';
    const { idToken, removeAccount, accounts } = this.props;    

    let check = window.confirm("Really to remove the account?");
    if (check) {
      const row = props.cell.getRow();
      const data = row.getData();

      const reqBodyObj = {
        email: data.email,
        uid: data.uid,
        from: 'Dashboard'
      };

      // do remove
      removeAccount(idToken, reqBodyObj, accounts);
    }
  }

  doReloadTable = (msg) => {
    // reload table
    const { refTable, sessionKey } = this.state;
    const keepTableInfo = getTableInfoFromSession(sessionKey);
    if (keepTableInfo) {
      setTimeout(() => {
        reloadTable(refTable, keepTableInfo, this.refFilterSearch);
        if (msg) {
          alert(msg);
        }        
      }, 50);
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { menuMode, status, errMsg } = this.props;
    if (prevProps.status !== status) {
      if (status === DELETE_CLOUD_ACCOUNT_SUCCESS) {
        // reload table
        this.doReloadTable('Remove the account success.');
      } else if (status === DELETE_CLOUD_ACCOUNT_FAIL) {
        if (errMsg) {
          // reload table
          this.doReloadTable(errMsg);
        }
      } else if (status === WAIT_INIT_ACCOUNTS) {
        // reload table
        this.doReloadTable(errMsg);
      }
    } else if (prevProps.menuMode !== menuMode) {
      // if menu chagne size(mode), need redraw table
      const { refTable } = this.state;
      if (refTable) {
        refTable.redraw(false);
      }      
    }
  }

  render() {
    const paginationSize = this.refListCommonFooter ? this.refListCommonFooter.getPaginationSize() : 50;
    const options = {
      movableRows: false,
      pagination: 'local',
      paginationSize: paginationSize
    };

    const date = new Date();
    const timestamp = moment(date).format('YYYYMMDD');
    const excelFileName = 'Cloud Account List ' + timestamp + '.csv';
    const { accounts, popLoading } = this.props;

    return (
      <div>
        <CommonListFooter tableId={this.tableId} refTable={this.state.refTable} refs={(ref) => {this.refListCommonFooter = ref;}} displayPaginationSize={paginationSize}></CommonListFooter>
        <div className='filter-bar'>
          <Row>
            <div className='area-list-title'>
              <div className='list-title'>Cloud Account</div>
            </div>
            <div className='area-filter'>
              <FilterSearch filterId='accountListFilter' refTable={this.state.refTable} refColumns={this.state.filterColumns} title='Search type'
                placeholder='Enter Account...' refs={(ref) => {this.refFilterSearch = ref;}}></FilterSearch>
            </div>
            <div className='area-table-tool-bar'>
              <ListSettingBtn tableId={this.tableId} refTable={this.state.refTable} refs={(ref) => {this.refTableToolBar = ref;}}
                visibleColumnsConfig={this.state.visibleColumnsConfig} defaultColumns={this.columns}>
              </ListSettingBtn>
            </div>
            <div className='area-list-btns' title='Export excel'>
              <span className='area-icon-btn-excel'>
                <ExcelFile filename={ excelFileName } element={<span className='icon-btn-export-excel'/>}>
                    <ExcelSheet data={ accounts } name="Accounts">
                      <ExcelColumn label="Account" value="email"/>
                      <ExcelColumn label="Created Date" value={(col) => col.createDate ? moment(col.createDate).format("YYYY/MM/DD") : ""}/>
                      <ExcelColumn label="Last Modified Date" value={(col) => col.lastModifiedDate ? moment(col.lastModifiedDate).format("YYYY/MM/DD") : ""}/>
                    </ExcelSheet>
                </ExcelFile>
              </span>
              <span className='area-icon-btn-reload' title='Reload list'><span className='icon-btn-reload' onClick={() => this.reloadList()} /></span>
            </div>
          </Row>
        </div>
        <div className='custom-list-table-area'>
          <ReactTabulator
            ref={ref => (this.ref = ref)}
            columns={this.columns}
            data={accounts}
            options={options}
            data-custom-attr="test-custom-attribute"
            className="custom-list-table"
            footerElement={commonListFooter}
            dataLoading={this.dataLoading}
            renderComplete={this.changePageNumber}
          />
        </div>
        <Loading loading={popLoading} center={true}></Loading>
      </div>
    )
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.cloudAccountReducers.status,
    accounts: state.cloudAccountReducers.accounts,
    popLoading: state.cloudAccountReducers.popLoading,
    errMsg: state.cloudAccountReducers.errMsg,
    menuMode: state.menuReducers.displayMode
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardAccountList, getAccountsData, removeAccount }
)(CloudAccountList))
